import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { IUser } from "./types";
import type { IBackendUser } from "../../services/user/type";

const initialState: IUser = {
  userId: "",
  firstName: "",
  lastName: "",
  givenName: "",
  email: "",
  isActive: false,
  createdOn: "",
  createdBy: "",
  roleName: "",
  roleId: 0,
  userTypeName: "",
  userTypeId: 0,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserFirstName: (state, action: PayloadAction<string>) => {
      state.firstName = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<IBackendUser>) => {
      return { ...state, ...action.payload };
    },
    clearUserInfo: () => {
      return initialState;
    },
  },
});

export const { setUserFirstName, setUserInfo, clearUserInfo } =
  userSlice.actions;
export default userSlice.reducer;
